/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import cn from 'classnames'
import React, { useState } from 'react'

import { withAnchor } from '../hooks'
import TablerIconPlay from '../Icon/icons/topic/player-play.svg'
import { Image as DatoImage } from 'react-datocms'
//

export const VIDEO_SOURCES = Object.freeze({
  Wistea: 'Wistea',
  Youtube: 'Youtube'
})

const Wistia = ({
  videoId = '',
  thumbnailVideo = null,
  thumbnail = null,
  videoSource = VIDEO_SOURCES.Youtube,
  width,
  height,
  playText = null
}) => {
  const [isPlaying, setIsPlaying] = useState(false)

  const calculateAspectRatio = () => {
    if (thumbnail && thumbnail.width && thumbnail.height) {
      return `${thumbnail.width}/${thumbnail.height}`
    } else if (width && height) {
      return `${width}/${height}`
    } else {
      return null
    }
  }

  const handleIsPlaying = () => {
    if (videoSource === VIDEO_SOURCES.Youtube) {
      setIsPlaying(!isPlaying)
    }
  }

  if (!videoId) return

  if (videoSource !== VIDEO_SOURCES.Youtube) {
    return null
  }

  const thumbnailContent = thumbnailVideo ? (
    thumbnail
  ) : thumbnail ? (
    <DatoImage
      data={thumbnail.responsiveImage}
      style={{ height: '100%' }}
      imgStyle={{ objectFit: 'contain' }}
    />
  ) : null

  return (
    <>
      <div
        className="c-media__youtube"
        style={{
          aspectRatio: `${calculateAspectRatio()}`
        }}
        onClick={() => handleIsPlaying()}
      >
        {thumbnailContent ? (
          thumbnailContent
        ) : (
          <img
            src={`https://img.youtube.com/vi/${videoId}/sddefault.jpg`}
            alt="Youtube Video Thumbnail"
          />
        )}
        <div
          className={cn('c-media__button', {
            'is-hidden': isPlaying,
            'c-media__button--withText': playText
          })}
        >
          <button aria-label="Play Button">
            <TablerIconPlay width="40" height="40" fill="#1c1c1c1" />
            {playText ? <span>{playText}</span> : null}
          </button>
        </div>
      </div>
      {isPlaying ? (
        <YTModal videoId={videoId} autoPlay={true} closeModal={handleIsPlaying} />
      ) : null}
    </>
  )
}

const YTModal = ({ videoId, autoPlay, closeModal = () => {} }) => {
  return (
    <div
      className={cn('c-media__yt-full-width', {
        'c-media__yt-full-width--isOpen': true
      })}
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        closeModal()
      }}
    >
      <iframe
        title="YouTube video player"
        allowFullScreen
        height="315px"
        src={`https://www.youtube.com/embed/${videoId}${autoPlay ? `?autoplay=1` : ''}`}
        width="560px"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      />
    </div>
  )
}

export default withAnchor(Wistia)
